import { Topic } from "../../topics/types";

export type AlertCard = {
    id: number;
    referenceId: number;
    referenceTable :AlertReferenceTableEnum;
    alertAI?: number;
    nps: string;
    answerDate: string;
    status: AlertStatusEnum;
    order: number;
    userId: number;
    userName: string;
    entryDate: number;
    comment: string;
};

export type ExportCSVData = {
    states: number[];
    userId: string;
    dateStart?: Date | null;
    dateEnd?: Date | null;
};

export type UpdateStatusAlert = {
    idAlert: number;
    droppableId: string;
    index: number;
};

export type SurveyAlertDto = {
    id: number;
    idSurvey: number;
    nps: string;
    createDate: string;
    answerDate: string;
    topics: Topic[];
    comment: string;
    feelingAI: number;
    originalFeelingAI: number;
    alertAI: number;
    originalAlertAI: number;
    messageAI: string;
    recommendationAI: string;
    idUserRelated: string;
    nameUserRelated: string;
};

export type AlertsFilterDto = {
    name: string;
    description: string;
    type: string;
    values?: string[];
}
export enum AlertStatusEnum {
    PendingToRead = 1,
    PendingResponse = 2,
    Response = 3,
    Revised = 4
}

export enum AlertReferenceTableEnum {
    SURVEY_IMPORT_RESULT,
    CLAIM
}